<template>
  <div>
    <table class="table is-fullwidth is-striped">
      <thead>
        <tr>
          <th>{{ $t('app.datetime') }}</th>
          <th>{{ $t('app.rights_issue') }}</th>
          <th>{{ $t('app.gratis') }}</th>
          <th>{{ $t('app.dividend') }}</th>
          <th>{{ $t('app.ratio') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" v-bind:key="item.id">
          <td>{{ item.Tarih }}</td>
          <td>{{ item.Bedelli }}</td>
          <td>{{ item.Bedelsiz }}</td>
          <td>{{ item.Temettu }}</td>
          <td>{{ item.Oran }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["symbol"])
  },
  data: function() {
    return {
      data: []
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_PROXY +
        "cmd=SirketSermaye?symbol=" +
          this.symbol +
          "?lang=" +
          this.$i18n.locale,
        { responseType: "json" }
      )
      .then(response => this.initJSON(response));
  },
  methods: {
    initJSON: function(response) {
      this.data = response.data;
    }
  }
};
</script>